import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalizationService } from './localization.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./localization.service";
var ProvinceService = /** @class */ (function () {
    function ProvinceService(http, baseUrl, localizationService) {
        this.http = http;
        this.baseUrl = baseUrl;
        this.localizationService = localizationService;
        this.apiUrl = this.baseUrl + "api/provinces";
    }
    ProvinceService.prototype.getProvinces = function () {
        var _this = this;
        return new Observable(function (subscriber) {
            _this.getProvincesCall(subscriber);
            _this.localizationService.addLangSubscriber(subscriber, function (obs) { return _this.getProvincesCall(obs); });
        });
    };
    ProvinceService.prototype.getProvincesCall = function (subscriber) {
        var code = this.localizationService.getLocale();
        if (ProvinceService.cache[code]) {
            subscriber.next(ProvinceService.cache[code]);
            return;
        }
        this.http.get("" + this.apiUrl).subscribe(function (provinces) {
            ProvinceService.cache[code] = provinces;
            subscriber.next(provinces);
        }, function (error) { return subscriber.error(error); });
    };
    ProvinceService.cache = {};
    ProvinceService.ngInjectableDef = i0.defineInjectable({ factory: function ProvinceService_Factory() { return new ProvinceService(i0.inject(i1.HttpClient), i0.inject("BASE_URL"), i0.inject(i2.LocalizationService)); }, token: ProvinceService, providedIn: "root" });
    return ProvinceService;
}());
export { ProvinceService };
